// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.DatePicker_dashboard__SCyzy {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.DatePicker_dashboardContain__KNHih {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_dashboardContain__KNHih,
.DatePicker_bodythemedark__VeCCE .DatePicker_dashboard__SCyzy,
.DatePicker_bodythemedark__VeCCE .DatePicker_cont2__Flk1f {
  background-Color: #0f1824;
}

.DatePicker_top_header__\\+nOVM .DatePicker_top_header_inner__d91Gw {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.DatePicker_cont2__Flk1f {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.DatePicker_subLink__3Yhy1 svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.DatePicker_footer__COVYd {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.DatePicker_bodythemelight__KT\\+uE {
  background-color: #fff;
  padding-top: 90px;
}

.DatePicker_bodythemedark__VeCCE {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.DatePicker_headerthemelight__PCbqd {
  background-color: #fff;
}

.DatePicker_headerthemedark__23baD {
  background-color: #132337;
}

.DatePicker_top_header__\\+nOVM {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.DatePicker_menuthemelight__XwJhe {
  background-color: #fff;
}

.DatePicker_menuthemedark__CjW52 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.DatePicker_menulinklight__6Rl7R span {
  color: #666666 !important;
}

.DatePicker_menulinklight__6Rl7R a {
  color: #CBCBCB !important;
}

.DatePicker_menulinklight__6Rl7R:hover span, .DatePicker_menulinklight__6Rl7R:hover a {
  color: #fff !important;
}

.DatePicker_menulinkdarkSelected__lPVQX {
  background-color: #1c2e45;
  color: #3b82f6;
}

.DatePicker_menuthemelight__XwJhe .DatePicker_menulinklightSelected__dUm8H {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.DatePicker_menulinkdark__9C\\+Pr {
  color: #92afd3 !important;
}

.DatePicker_menulinklight__6Rl7R:hover {
  color: #fff !important;
  background-color: #131F43;
}

.DatePicker_menulinklight__6Rl7R .DatePicker_sub_arrow__IkZht svg path {
  stroke: #CBCBCB !important;
}

.DatePicker_menulinklight__6Rl7R:hover .DatePicker_sub_arrow__IkZht svg path {
  stroke: #fff !important;
}

.DatePicker_menulinkdark__9C\\+Pr .DatePicker_sub_arrow__IkZht svg path {
  stroke: #92afd3 !important;
}

.DatePicker_menulinkdark__9C\\+Pr:hover .DatePicker_sub_arrow__IkZht svg path {
  stroke: #fff !important;
}

.DatePicker_menulinkdark__9C\\+Pr:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.DatePicker_headinglight__CfjfI {
  color: #60677e;
}

.DatePicker_headingdark__N9iIB {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.DatePicker_searchboxlight__i1iOa {
  background-color: #fff;
  border: none;
}

.DatePicker_searchboxdark__oMvud {
  background-color: #132337;
  color: #fff;
  border: none;
}

.DatePicker_searchboxdark__oMvud::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.DatePicker_tableheadlight__zuA0i {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.DatePicker_tableheadlight__zuA0i th {
  color: #fff;
}

thead .DatePicker_tableheadlight__zuA0i th:first-child,
thead .DatePicker_tableheaddark__T3kZM th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .DatePicker_tableheadlight__zuA0i th:last-child,
thead .DatePicker_tableheaddark__T3kZM th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.DatePicker_table__BVuZJ.DatePicker_table-borderless__m8J4U {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.DatePicker_tableheaddark__T3kZM {
  background-color: #132337;
  color: #fff;
}

.DatePicker_table-borderless__m8J4U tr:nth-child(even) {
  background-color: #F9FAFB;
}

.DatePicker_table-borderless__m8J4U .DatePicker_left-section__TDcGU {
  padding-top: 10px;
}

.DatePicker_tablebodylight__kglQT td,
.DatePicker_tablebodydark__5Lu2U td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.DatePicker_tablebodylight__kglQT {
  background-color: #fff;
}
.DatePicker_tablebodylight__kglQT:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.DatePicker_tablebodydark__5Lu2U {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.DatePicker_tablebodydark__5Lu2U:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.DatePicker_paginationlight__DfBr\\+ {
  color: #60677e !important;
  font-size: 13px !important;
}

.DatePicker_paginationdark__7EDdM {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.DatePicker_formthemelight__WDnm3 {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.DatePicker_formthemedark__pAMZ- {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.DatePicker_formthemedark__pAMZ- ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.DatePicker_viewformlight__LhoFH {
  background-color: #f3f6f9;
}

.DatePicker_permissionboxlight__QwDD7 {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.DatePicker_permissionboxdark__GWiJ6 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.DatePicker_errormsgclr__RKEwx {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.DatePicker_graphclrlight__MurAz {
  background-color: #fff;
}

.DatePicker_graphclrdark__xf26g {
  background-color: #132337;
}

/* 
Counter theme
*/
#DatePicker_card1bglight__ivl95 {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#DatePicker_card1bgdark__zCrJk {
  background: #392f28;
}

#DatePicker_card2bglight__wAIJD {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#DatePicker_card2bgdark__IBsfI {
  background: #1c3238;
}

#DatePicker_card3bglight__DQBBz {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#DatePicker_card3bgdark__gSKzR {
  background: #3a2434;
}

#DatePicker_card4bglight__bgI97 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#DatePicker_card4bgdark__ctc6o {
  background: #2f264f;
}

#DatePicker_card1bgdark__zCrJk a, #DatePicker_card1bgdark__zCrJk p,
#DatePicker_card2bgdark__IBsfI a, #DatePicker_card2bgdark__IBsfI p,
#DatePicker_card3bgdark__gSKzR a, #DatePicker_card3bgdark__gSKzR p,
#DatePicker_card4bgdark__ctc6o a, #DatePicker_card4bgdark__ctc6o p {
  color: #fff;
}

/* 
Action button theme
*/
.DatePicker_actionbtnlight__Nl29q {
  color: rgba(70, 71, 91, 0.8705882353);
}

.DatePicker_actionbtnlight__Nl29q:hover {
  cursor: pointer;
}

.DatePicker_actionbtndark__8SHb\\+ {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.DatePicker_profiledropdownlight__i1RBk {
  background-color: #fff;
}

.DatePicker_profiledropdowndark__PiHrY {
  background-color: #151521;
}

.DatePicker_settingsection__Gi8Me #DatePicker_addform__DoP5k.DatePicker_formthemedark__pAMZ- .DatePicker_savebtn__OzmN1 {
  background-color: #3b82f6;
  color: #fff;
}

#DatePicker_addform__DoP5k.DatePicker_formthemedark__pAMZ- .DatePicker_savebtn__OzmN1 {
  background-color: #3b82f6;
  color: #fff;
}

.DatePicker_profile_conatiner__onRr9 {
  border-radius: 5px !important;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_ag-theme-alpine__EaRIE .DatePicker_ag-row__QH3-O {
  background: #000 !important;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_formbtn__P031Y {
  background-color: #3b82f6;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_formbtn__P031Y:hover {
  background-color: #2563eb;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_resetbtn__T16qF {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_resetbtn__T16qF:hover {
  background-color: #3b82f6;
}

.DatePicker_headingdark__N9iIB span {
  background-color: #132337;
}

.DatePicker_resetbtn__T16qF {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.DatePicker_resetbtn__T16qF:hover,
.DatePicker_resetbtn__T16qF:active,
.DatePicker_resetbtn__T16qF:focus {
  background-color: #131F43;
  color: #fff;
}

.DatePicker_addBtn__KaUc- {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.DatePicker_addbtnlight__cPDuw {
  background-color: #38A169;
}

.DatePicker_addbtndark__NZ8ZV {
  background-color: #3b82f6;
}

.DatePicker_addbtndark__NZ8ZV:hover {
  background-color: #2563eb;
}

.DatePicker_formthemedark__pAMZ- label {
  color: #92afd3;
}

.DatePicker_addBtn__KaUc- svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.DatePicker_addBtn__KaUc-:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.DatePicker_cust_addBtn__KsLTe.DatePicker_addBtn__KaUc- svg {
  top: 2px;
}

.DatePicker_deleteBtn__U1zcf {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.DatePicker_deleteBtn__U1zcf {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.DatePicker_deleteBtn__U1zcf:active, .DatePicker_deleteBtn__U1zcf:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.DatePicker_deleteBtn__U1zcf svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.DatePicker_deleteBtn__U1zcf:hover,
.DatePicker_deleteBtn__U1zcf:active,
.DatePicker_deleteBtn__U1zcf:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.DatePicker_confirmBtn__Nn1Pc {
  background-color: #131F43;
}

.DatePicker_confirmBtn__Nn1Pc:hover,
.DatePicker_confirmBtn__Nn1Pc:active,
.DatePicker_confirmBtn__Nn1Pc:focus {
  background-color: #131F43;
}

.DatePicker_confirmBtn__Nn1Pc svg {
  top: 0;
}

.DatePicker_delPopContainer__rBXPt .DatePicker_modal-body__uKvp\\+ {
  padding: 25px;
  text-align: center;
}

.DatePicker_delPopContainer__rBXPt .DatePicker_delet_icon__26egz {
  margin-bottom: 11px;
}

.DatePicker_delPopContainer__rBXPt p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.DatePicker_arrowback__A7viE svg {
  fill: #000;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_arrowback__A7viE {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_arrowback__A7viE svg {
  fill: #3b82f6;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_drpdwn_btn__Zt-jF {
  background-color: #132337;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_empname__6vK02 {
  color: #92afd3 !important;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_navitemli__TQ90E a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_tabnavli__Med0v a.DatePicker_settingsgeneral__TzwrV,
.DatePicker_bodythemedark__VeCCE .DatePicker_tabnavli__Med0v a.DatePicker_settingslinks__EcLdO:hover {
  background-color: #3b82f6;
  color: #fff;
}

.DatePicker_bodythemedark__VeCCE .DatePicker_tabnavli__Med0v a.DatePicker_settingslinks__EcLdO {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.DatePicker_headerthemedark__23baD .DatePicker_dropdown_menu_contain__E2tOU {
  background-color: #1c2e45;
  color: #fff;
}

.DatePicker_headerthemedark__23baD .DatePicker_dropdown_menu_contain__E2tOU ul li a,
.DatePicker_headerthemedark__23baD .DatePicker_dropdown_menu_contain__E2tOU .DatePicker_dropdown_item__Sqoph,
.DatePicker_headerthemedark__23baD .DatePicker_dropdown_menu_contain__E2tOU .DatePicker_dropdown_item__Sqoph h5 {
  color: #fff;
}

.DatePicker_headerthemedark__23baD .DatePicker_dropdown_menu_contain__E2tOU ul li a:hover,
.DatePicker_headerthemedark__23baD .DatePicker_dropdown_menu_contain__E2tOU .DatePicker_dropdown_item__Sqoph:hover {
  background-color: #132337;
  color: #fff;
}

.DatePicker_dropdown_item__Sqoph:active {
  background-color: #F5F6FA;
}

.DatePicker_profile_arrrow_dwn__Hqhs4 {
  stroke: #132337;
}

.DatePicker_headerthemedark__23baD .DatePicker_profile_arrrow_dwn__Hqhs4 {
  stroke: #fff;
}

.DatePicker_dateinputbox1__Uoqte input,
.DatePicker_dateinputbox1__Uoqte span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .DatePicker_tableheadlight__zuA0i th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .DatePicker_dashboard__SCyzy {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .DatePicker_cont2__Flk1f {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .DatePicker_sectionright__m0\\+UB {
    float: unset !important;
  }
  .DatePicker_dashboard__SCyzy {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .DatePicker_cont2__Flk1f {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .DatePicker_bodythemelight__KT\\+uE, .DatePicker_bodythemedark__VeCCE {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .DatePicker_exer_modal_contain__Lfd5C .DatePicker_modal-dialog__WgiBo {
    max-width: 1055px;
  }
  .DatePicker_delPopContainer__rBXPt .DatePicker_modal-dialog__WgiBo {
    max-width: 350px;
  }
}
.DatePicker_datePickerContainer__GxGix, .DatePicker_datePickerDark__kK3Qj {
  width: 100%;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker, .DatePicker_datePickerDark__kK3Qj .react-date-picker {
  width: 100%;
  display: block;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__wrapper, .DatePicker_datePickerDark__kK3Qj .react-date-picker__wrapper {
  width: 100%;
  border: 1px solid #e5e7eb !important;
  border-radius: 5px;
  padding: 5px 12px !important;
  background-color: #ffffff !important;
  min-height: 50px;
  display: flex;
  align-items: center;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__inputGroup, .DatePicker_datePickerDark__kK3Qj .react-date-picker__inputGroup {
  flex-grow: 1;
  display: flex;
  align-items: center;
  min-width: 0;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__inputGroup__input, .DatePicker_datePickerDark__kK3Qj .react-date-picker__inputGroup__input {
  outline: none;
  border: none !important;
  background: transparent !important;
  padding: 0 4px !important;
  color: #1f2937 !important;
  font-size: 14px !important;
  min-height: unset !important;
  width: auto !important;
  flex-shrink: 0;
  box-shadow: none !important;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__inputGroup__input--has-value, .DatePicker_datePickerDark__kK3Qj .react-date-picker__inputGroup__input--has-value {
  font-weight: 500;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__inputGroup__divider, .DatePicker_datePickerDark__kK3Qj .react-date-picker__inputGroup__divider {
  padding: 0 6px;
  color: #727272 !important;
  font-weight: 400;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__inputGroup__leadingZero, .DatePicker_datePickerDark__kK3Qj .react-date-picker__inputGroup__leadingZero {
  display: none !important;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__button, .DatePicker_datePickerDark__kK3Qj .react-date-picker__button {
  padding: 4px;
  border: none;
  background: transparent;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__button:hover, .DatePicker_datePickerDark__kK3Qj .react-date-picker__button:hover {
  opacity: 0.7;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__button svg, .DatePicker_datePickerDark__kK3Qj .react-date-picker__button svg {
  stroke: #6b7280;
}
.DatePicker_datePickerContainer__GxGix .react-date-picker__calendar, .DatePicker_datePickerDark__kK3Qj .react-date-picker__calendar {
  z-index: 1000;
}

.DatePicker_datePickerDark__kK3Qj .react-date-picker__wrapper {
  background-color: #1f2937 !important;
  border-color: #374151 !important;
}
.DatePicker_datePickerDark__kK3Qj .react-date-picker__inputGroup__input {
  color: #fff !important;
}
.DatePicker_datePickerDark__kK3Qj .react-date-picker__button svg {
  stroke: #9ca3af;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/DatePicker/DatePicker.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAmDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,2BAAA;EACA,gBAAA;ACzEF;;AD2EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEF;;AD0EA;;;EAGE,yBAlEoB;ACLtB;;ADyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACtEF;;ADyEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAzHO;EA0HP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACpEF;;AD0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACvEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBAjGY;ACwBd;;AD4EA;;CAAA;AAGA;EACE,sBAxGY;EAyGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAvHgB;EAwHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBApHY;AC4Cd;;AD2EA;EACE,yBAnIgB;AC2DlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAxIY;ACiEd;;ADyEA;EACE,yBAtJgB;ACgFlB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAvKsB;EAwKtB,cAlLkB;AC4GpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAlNc;AC6IhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBA3Nc;ACsJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBA1MsB;EA2MtB,WAlMY;AC6Hd;;ADwEA;;CAAA;AAGA;EACE,cAtMe;ACiIjB;;ADwEA;EACE,cA1Me;ACqIjB;;ADwEA;;CAAA;AAGA;EACE,sBApNY;EAqNZ,YAAA;ACrEF;;ADwEA;EACE,yBApOgB;EAqOhB,WA1NY;EA2NZ,YAAA;ACrEF;;ADuEA;EACE,cA3Ne;ACuJjB;;ADuEA;;CAAA;AAGA;EACE,yBAnRc;EAoRd,8BAAA;ACpEF;;ADsEA;EACE,WAzOY;ACsKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAvPkB;EAwPlB,WAhQY;ACkMd;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBA9QY;ACoNd;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cApRe;AC0NjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA/SY;EAgTZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBA5SkB;EA6SlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAtTa;AC6PjB;;AD8DA;;CAAA;AAGA;EACE,yBArUgB;AC0QlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBApVoB;EAqVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAxVY;AC8Rd;;AD6DA;EACE,yBApVkB;AC0RpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBArWY;AC0Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA9WY;ACmTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAvXY;AC4Td;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAhYY;ACqUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WA3YY;ACgVd;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cArZe;AC4VjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBAzbkB;EA0blB,WAzaY;AC+Wd;;AD4DA;EACE,yBA7bkB;EA8blB,WA7aY;ACoXd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBA1ckB;ACiZpB;;AD4DA;EACE,yBA7cwB;ACoZ1B;;AD4DA;EACE,WAjcY;EAkcZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAxdkB;AC+ZpB;;AD6DA;EACE,yBAvdgB;AC6ZlB;;AD6DA;EACE,eAAA;EACA,gBArgBc;EAsgBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAngBc;EAogBd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAzgBc;EA0gBd,WA5dY;ACmad;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WAleY;EAmeZ,yBA9fY;EA+fZ,YAAA;EACA,eAAA;EACA,gBA1hBc;ACiehB;;AD4DA;EACE,yBArgBY;AC4cd;;AD2DA;EACE,yBA9fkB;ACscpB;;AD0DA;EACE,yBAhgBwB;ACyc1B;;AD0DA;EACE,cAtgBiB;AC+cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA/fY;EAggBZ,yBA3hBY;EA4hBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA/hBW;EAgiBX,WA5gBY;EA6gBZ,eAAA;EACA,gBAlkBc;EAmkBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBAziBW;EA0iBX,WAthBY;EAuhBZ,eAAA;EACA,gBA5kBc;EA6kBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA/jBW;EAgkBX,WA5iBY;EA6iBZ,YAAA;ACxDF;;AD2DA;EACE,yBA/lBc;ACuiBhB;;AD2DA;;;EAGE,yBArmBc;AC6iBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCAnmBc;EAomBd,cAxmBkB;AC8iBpB;;AD6DA;EACE,aA5mBkB;ACkjBpB;;AD6DA;EACE,yBAxmBgB;AC8iBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAvmBY;AC6iBd;;AD6DA;;EAEE,yBA7nBkB;EA8nBlB,WA7mBY;ACmjBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlnBY;ACyjBd;;AD4DA;EACE,yBA/nBsB;EAgoBtB,WAvnBY;AC8jBd;;AD4DA;;;EAGE,WA7nBY;ACokBd;;AD4DA;;EAEE,yBA7oBgB;EA8oBhB,WAnoBY;AC0kBd;;AD4DA;EACE,yBAtrBO;AC6nBT;;AD4DA;EACE,eAtpBgB;AC6lBlB;;AD4DA;EACE,YA/oBY;ACslBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AA1sBA;EACE,WAAA;AA4sBF;AAzsBI;EACE,WAAA;EACA,cAAA;AA2sBN;AAxsBI;EACE,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,4BAAA;EACA,oCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AA0sBN;AAvsBI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAysBN;AAtsBI;EACE,aAAA;EACA,uBAAA;EACA,kCAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,cAAA;EACA,2BAAA;AAwsBN;AAtsBM;EACI,gBAAA;AAwsBV;AApsBI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;AAssBN;AAnsBI;EACI,wBAAA;AAqsBR;AAlsBI;EACE,YAAA;EACA,YAAA;EACA,uBAAA;AAosBN;AAlsBM;EACE,YAAA;AAosBR;AAjsBM;EACE,eAAA;AAmsBR;AA/rBI;EACE,aAAA;AAisBN;;AAxrBI;EACE,oCAAA;EACA,gCAAA;AA2rBN;AAxrBI;EACE,sBAAA;AA0rBN;AAvrBI;EACE,eAAA;AAyrBN","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #DBEAFE;  \n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #D1FAE5;  \n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FEF3C7;  \n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #E9D5FF; \n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon1-color: #3B82F6;  \n$cardIcon2-color: #10B981;  \n$cardIcon3-color: #F59E0B;  \n$cardIcon4-color: #8B5CF6;  \n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import '../../styles/Variables/Variables.scss';\n\n.datePickerContainer {\n  width: 100%;\n\n  :global {\n    .react-date-picker {\n      width: 100%;\n      display: block;\n    }\n\n    .react-date-picker__wrapper {\n      width: 100%;\n      border: 1px solid #e5e7eb !important;\n      border-radius: 5px;\n      padding: 5px 12px !important;\n      background-color: #ffffff !important;\n      min-height: 50px;\n      display: flex;\n      align-items: center;\n    }\n\n    .react-date-picker__inputGroup {\n      flex-grow: 1;\n      display: flex;\n      align-items: center;\n      min-width: 0;\n    }\n\n    .react-date-picker__inputGroup__input {\n      outline: none;\n      border: none !important;\n      background: transparent !important;\n      padding: 0 4px !important;\n      color: #1f2937 !important;\n      font-size: 14px !important;\n      min-height: unset !important;\n      width: auto !important;\n      flex-shrink: 0;\n      box-shadow: none !important;\n\n      &--has-value {\n          font-weight: 500;\n      }\n    }\n\n    .react-date-picker__inputGroup__divider {\n      padding: 0 6px;\n      color: #727272 !important;\n      font-weight: 400;\n    }\n\n    .react-date-picker__inputGroup__leadingZero {\n        display: none !important;\n    }\n\n    .react-date-picker__button {\n      padding: 4px;\n      border: none;\n      background: transparent;\n\n      &:hover {\n        opacity: 0.7;\n      }\n\n      svg {\n        stroke: #6b7280;\n      }\n    }\n\n    .react-date-picker__calendar {\n      z-index: 1000;\n    }\n  }\n}\n\n.datePickerDark {\n  @extend .datePickerContainer;\n\n  :global {\n    .react-date-picker__wrapper {\n      background-color: #1f2937 !important;\n      border-color: #374151 !important;\n    }\n\n    .react-date-picker__inputGroup__input {\n      color: $white-color !important;\n    }\n\n    .react-date-picker__button svg {\n      stroke: #9ca3af;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `DatePicker_dashboard__SCyzy`,
	"dashboardContain": `DatePicker_dashboardContain__KNHih`,
	"bodythemedark": `DatePicker_bodythemedark__VeCCE`,
	"cont2": `DatePicker_cont2__Flk1f`,
	"top_header": `DatePicker_top_header__+nOVM`,
	"top_header_inner": `DatePicker_top_header_inner__d91Gw`,
	"subLink": `DatePicker_subLink__3Yhy1`,
	"footer": `DatePicker_footer__COVYd`,
	"bodythemelight": `DatePicker_bodythemelight__KT+uE`,
	"headerthemelight": `DatePicker_headerthemelight__PCbqd`,
	"headerthemedark": `DatePicker_headerthemedark__23baD`,
	"menuthemelight": `DatePicker_menuthemelight__XwJhe`,
	"menuthemedark": `DatePicker_menuthemedark__CjW52`,
	"menulinklight": `DatePicker_menulinklight__6Rl7R`,
	"menulinkdarkSelected": `DatePicker_menulinkdarkSelected__lPVQX`,
	"menulinklightSelected": `DatePicker_menulinklightSelected__dUm8H`,
	"menulinkdark": `DatePicker_menulinkdark__9C+Pr`,
	"sub_arrow": `DatePicker_sub_arrow__IkZht`,
	"headinglight": `DatePicker_headinglight__CfjfI`,
	"headingdark": `DatePicker_headingdark__N9iIB`,
	"searchboxlight": `DatePicker_searchboxlight__i1iOa`,
	"searchboxdark": `DatePicker_searchboxdark__oMvud`,
	"tableheadlight": `DatePicker_tableheadlight__zuA0i`,
	"tableheaddark": `DatePicker_tableheaddark__T3kZM`,
	"table": `DatePicker_table__BVuZJ`,
	"table-borderless": `DatePicker_table-borderless__m8J4U`,
	"left-section": `DatePicker_left-section__TDcGU`,
	"tablebodylight": `DatePicker_tablebodylight__kglQT`,
	"tablebodydark": `DatePicker_tablebodydark__5Lu2U`,
	"paginationlight": `DatePicker_paginationlight__DfBr+`,
	"paginationdark": `DatePicker_paginationdark__7EDdM`,
	"formthemelight": `DatePicker_formthemelight__WDnm3`,
	"formthemedark": `DatePicker_formthemedark__pAMZ-`,
	"viewformlight": `DatePicker_viewformlight__LhoFH`,
	"permissionboxlight": `DatePicker_permissionboxlight__QwDD7`,
	"permissionboxdark": `DatePicker_permissionboxdark__GWiJ6`,
	"errormsgclr": `DatePicker_errormsgclr__RKEwx`,
	"graphclrlight": `DatePicker_graphclrlight__MurAz`,
	"graphclrdark": `DatePicker_graphclrdark__xf26g`,
	"card1bglight": `DatePicker_card1bglight__ivl95`,
	"card1bgdark": `DatePicker_card1bgdark__zCrJk`,
	"card2bglight": `DatePicker_card2bglight__wAIJD`,
	"card2bgdark": `DatePicker_card2bgdark__IBsfI`,
	"card3bglight": `DatePicker_card3bglight__DQBBz`,
	"card3bgdark": `DatePicker_card3bgdark__gSKzR`,
	"card4bglight": `DatePicker_card4bglight__bgI97`,
	"card4bgdark": `DatePicker_card4bgdark__ctc6o`,
	"actionbtnlight": `DatePicker_actionbtnlight__Nl29q`,
	"actionbtndark": `DatePicker_actionbtndark__8SHb+`,
	"profiledropdownlight": `DatePicker_profiledropdownlight__i1RBk`,
	"profiledropdowndark": `DatePicker_profiledropdowndark__PiHrY`,
	"settingsection": `DatePicker_settingsection__Gi8Me`,
	"addform": `DatePicker_addform__DoP5k`,
	"savebtn": `DatePicker_savebtn__OzmN1`,
	"profile_conatiner": `DatePicker_profile_conatiner__onRr9`,
	"ag-theme-alpine": `DatePicker_ag-theme-alpine__EaRIE`,
	"ag-row": `DatePicker_ag-row__QH3-O`,
	"formbtn": `DatePicker_formbtn__P031Y`,
	"resetbtn": `DatePicker_resetbtn__T16qF`,
	"addBtn": `DatePicker_addBtn__KaUc-`,
	"addbtnlight": `DatePicker_addbtnlight__cPDuw`,
	"addbtndark": `DatePicker_addbtndark__NZ8ZV`,
	"cust_addBtn": `DatePicker_cust_addBtn__KsLTe`,
	"deleteBtn": `DatePicker_deleteBtn__U1zcf`,
	"confirmBtn": `DatePicker_confirmBtn__Nn1Pc`,
	"delPopContainer": `DatePicker_delPopContainer__rBXPt`,
	"modal-body": `DatePicker_modal-body__uKvp+`,
	"delet_icon": `DatePicker_delet_icon__26egz`,
	"arrowback": `DatePicker_arrowback__A7viE`,
	"drpdwn_btn": `DatePicker_drpdwn_btn__Zt-jF`,
	"empname": `DatePicker_empname__6vK02`,
	"navitemli": `DatePicker_navitemli__TQ90E`,
	"tabnavli": `DatePicker_tabnavli__Med0v`,
	"settingsgeneral": `DatePicker_settingsgeneral__TzwrV`,
	"settingslinks": `DatePicker_settingslinks__EcLdO`,
	"dropdown_menu_contain": `DatePicker_dropdown_menu_contain__E2tOU`,
	"dropdown_item": `DatePicker_dropdown_item__Sqoph`,
	"profile_arrrow_dwn": `DatePicker_profile_arrrow_dwn__Hqhs4`,
	"dateinputbox1": `DatePicker_dateinputbox1__Uoqte`,
	"sectionright": `DatePicker_sectionright__m0+UB`,
	"exer_modal_contain": `DatePicker_exer_modal_contain__Lfd5C`,
	"modal-dialog": `DatePicker_modal-dialog__WgiBo`,
	"datePickerContainer": `DatePicker_datePickerContainer__GxGix`,
	"datePickerDark": `DatePicker_datePickerDark__kK3Qj`
};
export default ___CSS_LOADER_EXPORT___;
